<template>
  <header class="bg-white border-b border-gray-100/80 z-10">
    <div class="flex items-center justify-between px-6 py-4">
      <div class="flex items-center gap-4">
        <!-- Mobile menu button -->
        <button
          @click="$emit('toggle-sidebar')"
          class="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer transition-colors"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <!-- Search -->
        <div class="hidden md:flex items-center">
          <div class="relative group">
            <input
              type="text"
              placeholder="Search..."
              class="w-64 pl-10 pr-4 py-2.5 bg-gray-50 border-0 rounded-lg text-sm focus:outline-none focus:ring-2 focus:bg-white transition-all"
              style="--tw-ring-color: #EDD97A;"
            >
            <svg class="absolute left-3 top-2.5 w-5 h-5 transition-colors" style="color: #5f4842;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-3">
        <!-- Back to Store -->
        <button
          @click="$emit('go-to-store')"
          class="hidden md:flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer hover:shadow-md"
          style="background-color: #5f4842; color: white;"
          onmouseover="this.style.backgroundColor='#4a342e'"
          onmouseout="this.style.backgroundColor='#5f4842'"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Go to Store
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
defineEmits<{
  'toggle-sidebar': []
  'go-to-store': []
}>()
</script>

